<script>
	import { useParams, navigate } from "svelte-navigator";
	import { import_recipe } from "../tastummy.ts";

	const params = useParams();
	let error_message = "";

	function import_recipe_by_id() {
		// get on the import recipe api
		import_recipe($params.id)
			.then((res) => {
				// forward to edit recipe page
				navigate("/recipe/" + res.data.recipe_id + "/edit");
			})
			.catch((e) => {
				// show error
				error_message = e.response.data.error;
			});
	}
</script>

<div>
	Import Recipe: <button on:click={import_recipe_by_id}>Import</button>
	{#if error_message}
		<p class="error">{error_message}</p>
	{/if}
</div>
